// extracted by mini-css-extract-plugin
module.exports = {"productCarousel":"Pf","itemsContainer":"Qf"};